import React from 'react';
import './Hero.css';

function Hero() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="hero">
      <div className="airplane-container">
        <img src="/aeroplane.png" alt="Airplane" className="airplane" loading="lazy" />
      </div>
      <div className="container">
        <div className="hero-content">
          <div className="animated-logo fade-in"></div>
          <h2 className="typing fade-in fade-in-delay-1">Reliable Courier and Cargo Services in Singapore</h2>
          <p className="fade-in fade-in-delay-2">
            Reliable courier and cargo company in Singapore offering same-day delivery,
            express shipping, and international import & export services.
          </p>
          <button className="cta-button fade-in fade-in-delay-3" onClick={scrollToContact}>
            Request a Quote
          </button>
        </div>
      </div>
    </section>
  );
}

export default Hero;